import { render } from "./ReviewCampaign.vue?vue&type=template&id=61536444&scoped=true"
import script from "./ReviewCampaign.vue?vue&type=script&lang=js"
export * from "./ReviewCampaign.vue?vue&type=script&lang=js"

import "./ReviewCampaign.vue?vue&type=style&index=0&id=61536444&scoped=true&lang=css"

import exportComponent from "/Users/bytedance/New/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61536444"]])

export default __exports__